import React, { useState } from 'react'
import { gql, useQuery } from '@apollo/client'
import {
  Container, Paper, Typography, Box, CircularProgress,
  Table, TableHead, TableRow, TableCell, TableBody, Chip, TextField, MenuItem,
  Tooltip, IconButton,
} from '@mui/material'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { getQorRecurringCharges } from '../apollo/queries'

const GET_RECURRING = gql`${getQorRecurringCharges}`

const KIND_FILTERS = ['', 'SETUP', 'RENEWAL']

export default function QorRecurring() {
  const [kind, setKind] = useState('')

  const { data, loading } = useQuery(GET_RECURRING, {
    variables: { kind: kind || undefined, limit: 200, offset: 0 },
    fetchPolicy: 'network-only',
  })

  const rows = data?.qorRecurringCharges?.rows ?? []
  const count = data?.qorRecurringCharges?.count ?? 0
  const copy = (v) => { if (v) navigator.clipboard?.writeText(v) }

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 6 }}>
      <Paper sx={{ p: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
          <AutorenewIcon color="primary" />
          <Typography variant="h5" sx={{ fontWeight: 700 }}>Black Card Recurring (QorCommerce)</Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Every QorCommerce Black Card charge — the initial signup and each monthly
          renewal — with its gateway transaction ID and result. This is the recurring
          history for QorPay&apos;s certification sheet.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
          <TextField
            select size="small" label="Charge type" value={kind}
            onChange={(e) => setKind(e.target.value)} sx={{ width: 200 }}
          >
            {KIND_FILTERS.map((k) => <MenuItem key={k || 'all'} value={k}>{k || 'All'}</MenuItem>)}
          </TextField>
          <Typography variant="caption" color="text.secondary">{count} total</Typography>
        </Box>

        {loading ? <CircularProgress size={24} /> : (
          <Box sx={{ overflowX: 'auto' }}>
          <Table size="small" sx={{ minWidth: 860 }}>
            <TableHead>
              <TableRow>
                <TableCell>Customer</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Transaction ID</TableCell>
                <TableCell>Recurring ID</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell>Result</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={8}><Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>No recurring charges yet.</Typography></TableCell></TableRow>
              )}
              {rows.map((c) => (
                <TableRow key={c._id} hover>
                  <TableCell>{c.userName || `User ${c.userId}`}</TableCell>
                  <TableCell><Typography variant="caption">{c.userEmail || '—'}</Typography></TableCell>
                  <TableCell><Chip size="small" label={c.kind} color={c.kind === 'SETUP' ? 'info' : 'default'} /></TableCell>
                  <TableCell>
                    {c.qorTransactionId ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography variant="caption" sx={{ fontFamily: 'monospace' }}>{c.qorTransactionId}</Typography>
                        <Tooltip title="Copy"><IconButton size="small" onClick={() => copy(c.qorTransactionId)}><ContentCopyIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
                      </Box>
                    ) : <Typography variant="caption" color="text.secondary">—</Typography>}
                  </TableCell>
                  <TableCell><Typography variant="caption" sx={{ fontFamily: 'monospace' }}>{c.qorRecurringTxnId || '—'}</Typography></TableCell>
                  <TableCell align="right">${Number(c.amount).toFixed(2)}</TableCell>
                  <TableCell>
                    <Chip size="small" color={c.result === 'APPROVED' ? 'success' : 'error'} label={c.result} />
                  </TableCell>
                  <TableCell><Typography variant="caption">{c.createdAt ? new Date(c.createdAt).toLocaleString() : '—'}</Typography></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </Box>
        )}
      </Paper>
    </Container>
  )
}
